import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { addToCart } from '../../../features/cartProducts/cartSlice';
import { addToWishList } from '../../../features/wishlist/wishlistSlice';


const Product = ({ product, relPd }) => {
    const { cardImg, name, prvPrice, price, _id: id, stock } = product;

    const { t } = useTranslation();

    const dispatch = useDispatch();
    const { wishlist } = useSelector((state) => state.wishlist);
    const wishItem = wishlist && wishlist.find((item) => item._id === id);

    const handleAddToCart = () => {
        dispatch(
            addToCart(product)
        )
    }

    const handleAddtTowishlist = () => {
        dispatch(
            addToWishList(product)
        )
    }
    return (
        <div className={`h_c_product   ${relPd && 'mx-2'}`}>
            <div className='border-amber-500'>
                <div className='relative  pd-img-div h-[180px] w-full border-b-4 border-bnd-1'>
                    <div className="md:border-[1px] md:border-b-0 md:border-orange-100 h-full w-full">
                        <Link to={`/products/${id}`}>
                            <img className='object-cover h-full w-full' src={cardImg} alt="" />
                        </Link>
                    </div>
                    {
                        stock <= 0 &&
                        <div className="absolute text-center grid content-center bg-red-600 opacity-75 top-16 left-0 h-12 w-full">
                            <h3 className='text-white text-xl'>{t('home.obPd.p.st')}</h3>
                        </div>
                    }
                </div>
                <div className='product-content p-2 text-center bg-bnd-3'>
                    <div>
                        <Link to={`/products/${id}`} className="text-link">
                            <p className='text-[17px] font-medium md:whitespace-nowrap'>{name.length > 28 ? name.substring(28, 0) + ".." : name}</p>
                        </Link>
                        <p className='pd-crprice font-semibold line-through pl-3 text-redbnd font-poppins'>{Number(price) < Number(prvPrice) && (prvPrice + `${t('home.obPd.p.tk')}`)}</p>
                        <p className={`pd-prvprice font-semibold pl-3 pb-1.5 text-black-600 font-poppins ${Number(price) > Number(prvPrice) && 'mt-[16px] mb-[15px]'}`}>{price} {t('home.obPd.p.tk')}</p>
                    </div>
                </div>
                <div className='pd-btns grid grid-cols-4 select-none'>
                    <div className='bg-slate-200 p-[5px] text-center cursor-pointer'>
                        <i onClick={handleAddtTowishlist} className={`fa fa-heart text-2xl ${wishItem && 'text-red-600'}`} aria-hidden="true"></i>
                    </div>
                    <div onClick={handleAddToCart} className='col-span-3 bg-bnd-2  p-[10px] text-white text-sm font-semibold font-poppins text-center cursor-pointer'>
                    {t('home.obPd.p.atc')}
                    </div>
                </div>
            </div>
        </div >

    );
};

export default Product;